import { render, staticRenderFns } from "./PhotosEmpty.vue?vue&type=template&id=256aaa5a&scoped=true&"
import script from "./PhotosEmpty.vue?vue&type=script&lang=js&"
export * from "./PhotosEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PhotosEmpty.vue?vue&type=style&index=0&id=256aaa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256aaa5a",
  null
  
)

export default component.exports